import React, { useState, useEffect } from 'react';
import { Worker } from '@react-pdf-viewer/core';
// Import the main component
import { Viewer } from '@react-pdf-viewer/core';
// Import the styles
import '@react-pdf-viewer/core/lib/styles/index.css';
import { ProgressBar } from '@react-pdf-viewer/core';

import { fullScreenPlugin } from '@react-pdf-viewer/full-screen';
import { ExitFullScreenIcon, FullScreenIcon } from '@react-pdf-viewer/full-screen';
// Import styles
import '@react-pdf-viewer/full-screen/lib/styles/index.css';
const PDFViewer = ({ base64Data }) => {
    return (
        <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
            <div style={{
                border: '1px solid rgba(0, 0, 0, 0.3)',
                width: "100%"
            }}>
                <Viewer
                    fileUrl={`data:application/pdf;base64,${base64Data}`}
                    renderLoader={(percentages) => (
                        <ProgressBar progress={Math.round(percentages)} />
                    )}
                    plugins={[fullScreenPlugin]}
                    theme={{
                        theme: 'light',
                    }}
                />
            </div>
        </Worker>
    );
};

export default PDFViewer;